<div class="min-h-screen bg-gray-50">
  <app-header [cartCount]="productService.getLocalCartProductLength()"></app-header>

  <ng-container *ngIf="restaurant; else notFound">
    <!-- Restaurant Header -->
    <div class="relative h-64 md:h-80">
      <img [src]="restaurant.image" [alt]="restaurant.name" class="w-full h-full object-cover" />
      <div class="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20"></div>
      <div class="absolute inset-0 flex items-end">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6 w-full">
          <button (click)="goBack()" class="flex items-center text-white mb-4 hover:text-orange-300 transition-colors">
            <lucide-icon name="arrow-left" class="w-5 h-5 mr-2"></lucide-icon>
            Back to Restaurants
          </button>
          <div class="flex items-end justify-between">
            <div>
              <h1 class="text-3xl md:text-4xl font-bold text-white">{{ restaurant.name }}</h1>
              <p class="text-white/80 mt-1">{{ restaurant.tagline }}</p>
              <!-- <div class="flex items-center space-x-4 mt-3">
                <span
                  class="flex items-center bg-teal-500/90 backdrop-blur-sm rounded-full px-3 py-1 text-white text-sm">
                  <!-- <lucide-icon name="tag" class="w-4 h-4 mr-1"></lucide-icon> --
                  {{ restaurant.offer}}
                </span>
              </div> -->
              <div class="flex items-center space-x-4 mt-3">
                <div class="bg-teal-500/90 backdrop-blur-sm rounded-full px-3 py-1 text-white text-sm">
                  <div>{{ restaurant.offer }}</div>
                  <!-- <div class="text-sm mt-0.5">Only at capitalfood.in</div> -->
                </div>
              </div>
            </div>
            <div class="hidden md:block w-20 h-20 rounded-2xl bg-white shadow-xl p-1">
              <img [src]="restaurant.logo + '?ts=' + timestamp" [alt]="restaurant.name + ' logo'"
                class="w-full h-full object-cover rounded-xl" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Menu Section -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- Search and Filters -->
      <div class="flex flex-col sm:flex-row gap-4 mb-6">
        <div class="relative flex-1">
          <lucide-icon name="search"
            class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"></lucide-icon>
          <input type="text" [(ngModel)]="searchQuery" placeholder="Search menu items..."
            class="w-full pl-10 pr-4 py-2 rounded-full border border-gray-200 focus:outline-none focus:border-orange-500" />
        </div>
        <div class="flex flex-wrap gap-2">
          <button (click)="setFilter('all')" [class.bg-orange-500]="filterType === 'all'"
            [class.text-white]="filterType === 'all'"
            class="rounded-full px-4 py-2 border border-gray-300 font-medium hover:bg-orange-500 hover:text-white hover:border-orange-500 transition-all">
            All
          </button>
          <button (click)="setFilter('veg')" [class.bg-green-600]="filterType === 'veg'"
            [class.text-white]="filterType === 'veg'"
            class="rounded-full px-4 py-2 border border-gray-300 font-medium flex items-center hover:bg-green-600 hover:text-white hover:border-green-600 transition-all">
            <lucide-icon name="leaf" class="w-4 h-4 mr-1"></lucide-icon> Veg
          </button>
          <button (click)="setFilter('nonveg')" [class.bg-red-600]="filterType === 'nonveg'"
            [class.text-white]="filterType === 'nonveg'"
            class="rounded-full px-4 py-2 border border-gray-300 font-medium flex items-center hover:bg-red-600 hover:text-white hover:border-red-600 transition-all">
            <lucide-icon name="drumstick" class="w-4 h-4 mr-1"></lucide-icon> Non-Veg
          </button>
          <button *ngFor="let group of subGroups" (click)="selectSubGroup(group)"
            [class.bg-blue-500]="selectedSubGroup === group" [class.text-white]="selectedSubGroup === group" class="rounded-full px-4 py-2 border border-gray-300 font-medium 
           hover:bg-blue-500 hover:text-white hover:border-blue-500 transition-all">
            {{ group }}
          </button>
        </div>
      </div>

      <!-- Menu Items Grid -->
      <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div *ngFor="let item of filteredItems" (click)="openPrebookPopup(item)"
          class="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden border border-gray-100">
          <div class="flex">
            <!-- Image --
            <div class="w-32 h-32 sm:w-40 sm:h-40 flex-shrink-0 relative">
              <img [src]="'../../../../assets/img/' + item.product_Picture" [alt]="item.product_Name"
                class="w-full h-full object-cover" onerror="this.src='../../../../assets/img/defaultCake.webp';" />
              <span *ngIf="item.bestseller"
                class="absolute top-2 left-2 bg-yellow-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
                Bestseller
              </span>
            </div>

            <!-- Content --
            <div class="flex-1 p-4 flex flex-col justify-between">
              <div>
                <div class="flex items-center space-x-2 mb-1">
                  <div *ngIf="item.food_Type == 'Veg'"
                    class="w-4 h-4 min-w-4 min-h-4 border-2 border-green-600 flex items-center justify-center">
                    <div class="w-2 h-2 bg-green-600 rounded-full"></div>
                  </div>
                  <div *ngIf="item.food_Type == 'Non-Veg'"
                    class="w-4 h-4 min-w-4 min-h-4 border-2 border-red-600 flex items-center justify-center">
                    <div class="w-2 h-2 bg-red-600 rounded-full"></div>
                  </div>
                  <h3 class="font-semibold text-gray-900">{{ item.product_Name }}</h3>
                </div>
                <p class="text-sm text-gray-500 line-clamp-2">{{ item.description }}</p>
              </div>

              <div class="flex items-center justify-between mt-3">
                <span class="text-lg font-bold text-gray-900">₹{{ item.net_Sale_Price | number: "1.2-2" }}</span>
                <ng-container *ngIf="getCartQuantity(item.product_Code) > 0; else addButton">
                  <div class="flex items-center space-x-2 bg-orange-50 rounded-lg p-1">
                    <button (click)="updateQuantity(item.product_Code, getCartQuantity(item.product_Code) - 1)"
                      class="w-8 h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50 transition-colors">
                      <lucide-icon name="minus" class="w-4 h-4 text-orange-500"></lucide-icon>
                    </button>
                    <span class="w-8 text-center font-semibold text-orange-600">{{ getCartQuantity(item.product_Code)
                      }}</span>
                    <button (click)="updateQuantity(item.product_Code, getCartQuantity(item.product_Code) + 1)"
                      class="w-8 h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50 transition-colors">
                      <lucide-icon name="plus" class="w-4 h-4 text-orange-500"></lucide-icon>
                    </button>
                  </div>
                </ng-container>
                <ng-template #addButton>
                  <button type="button" (click)="addToCart(item)"
                    class="bg-orange-500 hover:bg-orange-600 text-white rounded-lg px-4 py-2 text-sm font-medium">
                    Prebook & Save 30%
                  </button>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div *ngFor="let item of filteredItems" (click)="openPrebookPopup(item)"
          class="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden border border-gray-100">
          <div class="flex flex-col h-full">
            <!-- Top section: Image + Name & Description -->
            <div class="flex p-3 sm:p-4">
              <!-- Image -->
              <div class="w-32 h-32 sm:w-32 sm:h-32 flex-shrink-0 relative">
                <img [src]="'../../../../assets/img/' + item.product_Picture + '?ts=' + timestamp" [alt]="item.product_Name"
                  class="w-full h-full object-cover rounded-lg"
                  onerror="this.src='../../../../assets/img/defaultCake.webp';" />
                <span *ngIf="item.bestseller"
                  class="absolute top-1 left-1 sm:top-2 sm:left-2 bg-yellow-500 text-white text-[10px] sm:text-xs px-1.5 py-0.5 sm:px-2 sm:py-0.5 rounded-full font-medium">
                  Bestseller
                </span>
              </div>

              <!-- Name & Description -->
              <div class="flex-1 mt-1 ml-3 sm:ml-4 min-w-0">
                <div class="flex items-start space-x-2 mb-1">
                  <div *ngIf="item.food_Type == 'Veg'"
                    class="w-3.5 h-3.5 sm:w-4 sm:h-4 min-w-3.5 sm:min-w-4 min-h-3.5 sm:min-h-4 border-2 border-green-600 flex items-center justify-center flex-shrink-0 mt-0.5 sm:mt-0.5">
                    <div class="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-green-600 rounded-full"></div>
                  </div>
                  <div *ngIf="item.food_Type == 'Non-Veg'"
                    class="w-3.5 h-3.5 sm:w-4 sm:h-4 min-w-3.5 sm:min-w-4 min-h-3.5 sm:min-h-4 border-2 border-red-600 flex items-center justify-center flex-shrink-0 mt-0.5 sm:mt-0.5">
                    <div class="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-red-600 rounded-full"></div>
                  </div>
                  <h3 class="font-semibold text-gray-900 text-[14px] sm:text-base flex-1">{{ item.product_Name }}</h3>
                </div>
                <p class="text-[12px] sm:text-sm text-gray-500 line-clamp-6 break-words">{{ item.description }}</p>
              </div>
            </div>

            <!-- Bottom section: Price & Button -->
            <div class="flex items-center justify-between p-3 pb-1 sm:p-4 pt-0 sm:pt-0 mt-auto">
              <span class="text-base sm:text-lg font-bold text-gray-900 flex-shrink-0 ml-8 tabular-nums">₹{{
                item.net_Sale_Price | number: "1.2-2" }}</span>
              <ng-container *ngIf="getCartQuantity(item.product_Code) > 0; else addButton">
                <div
                  class="flex items-center space-x-1 sm:space-x-2 bg-teal-500/90 text-white rounded-lg p-0.5 sm:p-1 flex-shrink-0">
                  <button
                    (click)="$event.stopPropagation(); updateQuantity(item.product_Code, getCartQuantity(item.product_Code) - 1)"
                    class="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50 transition-colors">
                    <lucide-icon name="minus" class="w-3 h-3 sm:w-4 sm:h-4 text-orange-500"></lucide-icon>
                  </button>
                  <span class="w-6 sm:w-8 text-center font-semibold text-white text-sm sm:text-base">{{
                    getCartQuantity(item.product_Code)
                    }}</span>
                  <button
                    (click)="$event.stopPropagation(); updateQuantity(item.product_Code, getCartQuantity(item.product_Code) + 1)"
                    class="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50 transition-colors">
                    <lucide-icon name="plus" class="w-3 h-3 sm:w-4 sm:h-4 text-orange-500"></lucide-icon>
                  </button>
                </div>
              </ng-container>
              <!-- <ng-template #addButton>
          <button type="button" (click)="addToCart(item)"
            class="bg-teal-500/90 text-white rounded-lg px-2 sm:px-4 py-1 sm:py-2 text-[10px] sm:text-sm font-medium">
            Prebook & Save 30% Only at capitalfood.in
          </button>
        </ng-template> -->
              <ng-template #addButton>
                <button type="button" (click)="$event.stopPropagation(); addToCart(item)"
                  class="bg-teal-500/90 text-white rounded-lg text-[10px] sm:text-sm font-medium hover:bg-teal-600 transition-colors pt-[0.3rem] pb-[0.3rem] pl-[0.3rem] pr-[0.3rem]">
                  <div class="flex items-center justify-center gap-1 sm:gap-2">
                    <div class="text-left text-[10px] sm:text-sm responsive-line-height">
                      <div>BULK</div>
                      <div>ORDER</div>
                      <div>HERE</div>
                    </div>
                    <div class="self-stretch w-px bg-white/60 mx-1"></div>
                    <div class="text-[10px] sm:text-sm opacity-95 whitespace-nowrap">Prebook & Save 50%</div>
                  </div>
                </button>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <!--Pop up-->
      <div *ngIf="selectedItem" class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
        (click)="closePopup()">

        <!-- Dialog - with subtle shadow and reduced backdrop blur -->
        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-auto overflow-hidden animate-popup relative"
          (click)="$event.stopPropagation()">

          <!-- IMAGE SECTION (Top) -->
          <div class="relative w-full h-56 bg-gray-100">
            <!-- Close Button - Repositioned INSIDE the image area, at top-right corner of image -->
            <button (click)="closePopup()"
              class="absolute top-2 right-2 bg-white/90 hover:bg-white rounded-full p-1.5 shadow-md z-10 transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-400"
              aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-700" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <!-- Product Image -->
            <img [src]="'../../../../assets/img/' + selectedItem.product_Picture + '?ts=' + timestamp" class="w-full h-full object-cover"
              onerror="this.src='../../../../assets/img/defaultCake.webp';" alt="{{ selectedItem.product_Name }}" />

            <!-- Bestseller Badge -->
            <span *ngIf="selectedItem.bestseller"
              class="absolute top-2 left-2 bg-amber-500 text-white text-xs px-2 py-0.5 rounded-full font-semibold shadow-sm z-10">
              Bestseller
            </span>
          </div>

          <!-- CONTENT SECTION -->
          <div class="p-5 pb-2 flex flex-col gap-3">

            <!-- Header: Veg/Non-Veg + Name -->
            <div class="flex items-center gap-2">
              <!-- Veg/Non-Veg Indicator -->
              <div *ngIf="selectedItem.food_Type == 'Veg'"
                class="w-4 h-4 min-w-4 min-h-4 border-2 border-green-600 flex items-center justify-center">
                <div class="w-2 h-2 bg-green-600 rounded-full"></div>
              </div>
              <div *ngIf="selectedItem.food_Type == 'Non-Veg'"
                class="w-4 h-4 min-w-4 min-h-4 border-2 border-red-600 flex items-center justify-center">
                <div class="w-2 h-2 bg-red-600 rounded-full"></div>
              </div>

              <h2 class="text-base font-bold text-gray-900 tracking-tight">
                {{ selectedItem.product_Name }}
              </h2>
            </div>

            <!-- Full Description -->
            <p class="text-gray-600 text-sm leading-relaxed border-l-2 border-orange-200 pl-3">
              {{ selectedItem.description || 'No description available.' }}
            </p>

            <!-- Price & Add to Cart Button - Fixed Layout -->
            <div class="flex items-end justify-between gap-3 mt-2 pt-3 border-t border-gray-100">
              <!-- Price Section -->
              <div class="flex-shrink-0">

                <div class="flex items-baseline gap-2">
                  <span class="text-lg font-bold text-gray-900">
                    ₹{{ selectedItem.net_Sale_Price | number:'1.2-2' }}
                  </span>

                </div>
              </div>

              <!-- Button Section - Fixed Width -->
              <!-- <button (click)="addToCart(selectedItem)"
                class="bg-orange-500 hover:bg-orange-600 active:bg-orange-700 text-white px-2 py-2 rounded-lg font-semibold transition-all duration-200 shadow-md hover:shadow-lg flex items-center gap-1.5 text-xs whitespace-nowrap">

                Prebook & Save 30%
              </button> -->
              <!-- <button type="button" (click)="addToCart(selectedItem)"
                class="bg-teal-500/90 text-white rounded-lg px-2 sm:px-4 py-1 sm:py-2 text-[10px] sm:text-sm font-medium">
                <div>Bulk Order: Prebook & Save 30%</div>
              </button> -->
              <ng-container *ngIf="getCartQuantity(selectedItem.product_Code) > 0; else addButton">
                <div
                  class="flex items-center space-x-1 sm:space-x-2 bg-teal-500/90 text-white rounded-lg p-0.5 sm:p-1 flex-shrink-0">
                  <button
                    (click)="$event.stopPropagation(); updateQuantity(selectedItem.product_Code, getCartQuantity(selectedItem.product_Code) - 1)"
                    class="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50 transition-colors">
                    <lucide-icon name="minus" class="w-3 h-3 sm:w-4 sm:h-4 text-orange-500"></lucide-icon>
                  </button>
                  <span class="w-6 sm:w-8 text-center font-semibold text-white text-sm sm:text-base">{{
                    getCartQuantity(selectedItem.product_Code)
                    }}</span>
                  <button
                    (click)="$event.stopPropagation(); updateQuantity(selectedItem.product_Code, getCartQuantity(selectedItem.product_Code) + 1)"
                    class="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-white rounded-lg shadow-sm hover:bg-gray-50 transition-colors">
                    <lucide-icon name="plus" class="w-3 h-3 sm:w-4 sm:h-4 text-orange-500"></lucide-icon>
                  </button>
                </div>
              </ng-container>
              <ng-template #addButton>
              <button type="button" (click)="addToCart(selectedItem)"
                class="bg-teal-500/90 text-white rounded-lg text-[10px] sm:text-sm font-medium hover:bg-teal-600 transition-colors pt-[0.3rem] pb-[0.3rem] pl-[0.3rem] pr-[0.3rem]">
                <div class="flex items-center justify-center gap-1 sm:gap-2">
                  <div class="text-left text-[10px] sm:text-sm responsive-line-height">
                    <div>BULK</div>
                    <div>ORDER</div>
                    <div>HERE</div>
                  </div>
                  <div class="self-stretch w-px bg-white/60 mx-1"></div>
                  <div class="text-[10px] sm:text-sm opacity-95 whitespace-nowrap">Prebook & Save 30%</div>
                </div>
              </button>
              </ng-template>
            </div>

          </div>
        </div>
      </div>

      <div *ngIf="filteredItems.length === 0" class="text-center py-12">
        <p class="text-gray-500">No items found matching your criteria.</p>
      </div>
    </div>

    <!-- <div class="fixed z-50 
            bottom-[0.2rem] right-4 left-4  md:top-[75%] md:bottom-auto md:right-[0.5rem] md:left-auto
            md:-translate-y-1/2
            bg-[#13e7e2] backdrop-blur-md border border-orange-100
            rounded-xl px-3 py-2
            shadow-lg hover:shadow-xl
            flex md:flex-col flex-row items-center justify-between md:justify-center
            gap-2 md:gap-4
            transition-all duration-300 ease-in-out
            animate-attention"> -->
            <!-- #13e7e2 -->
            <!-- #55e3d2e6 -->
<!-- <div
  class="fixed z-50 
         right-4 left-4 md:left-auto md:right-[0.5rem]
         bg-[#13e7e2] backdrop-blur-md border border-orange-100
         rounded-xl px-3 py-2 shadow-lg hover:shadow-xl
         flex md:flex-col flex-row items-center justify-between md:justify-center
         gap-2 md:gap-4 animate-attention
         transition-all duration-500 ease-in-out"
  [ngStyle]="{
    top: isSticky ? '50%' : '480px',
    transform: isSticky ? 'translateY(-50%)' : 'translateY(0)'
  }"
> -->

<div
  class="fixed z-50 
         bottom-[0.2rem] right-4 left-4 
         md:left-auto md:right-[0.5rem] md:bottom-auto
         bg-[#13e7e2] backdrop-blur-md border border-orange-100
         rounded-xl px-3 py-2 shadow-lg hover:shadow-xl
         flex md:flex-col flex-row items-center justify-between md:justify-center
         gap-2 md:gap-4 animate-attention
         transition-all duration-500 ease-in-out"
  [ngStyle]="isDesktop ? {
    top: isSticky ? '50%' : '480px',
    transform: isSticky ? 'translateY(-50%)' : 'translateY(0)'
  } : {}"
>
      <!-- Text -->
      <div class="flex flex-col text-center leading-tight">
        <span style="font-weight: bold;" class="text-[#E31212] text-[8px] leading-[10px]">
          Select Partner
        </span>
        <span class="text-sm font-medium text-white">
          Order Now
        </span>
      </div>

      <!-- Icons -->
      <div class="flex md:flex-col flex-row items-center gap-2">

        <img class="h-5 cursor-pointer hover:scale-110 transition-transform duration-200"
          src="../../../../assets/img/swiggy.webp" alt="Swiggy" (click)="redirectToPartner(restaurant.id, 'Swiggy')" />


        <!-- Divider -->
        <div class="md:w-6 md:h-[2px] w-[2px] h-6 
                bg-gradient-to-b md:bg-gradient-to-r 
                from-transparent via-red-500 to-transparent">
        </div>

        <img class="h-5 cursor-pointer hover:scale-110 transition-transform duration-200"
          src="../../../../assets/img/zomato.webp" alt="Zomato" (click)="redirectToPartner(restaurant.id, 'Zomato')" />
    
    </div>

    </div>

    <!-- Floating Cart Button -->
    <div *ngIf="productService.getLocalCartProductLength() > 0" class="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
      <button (click)="goToCart()"
        class="bg-orange-500 hover:bg-orange-600 text-white rounded-full px-8 py-4 shadow-xl flex items-center space-x-3">
        <span class="bg-white/20 rounded-full px-3 py-1 text-sm">{{ productService.getLocalCartProductLength() }}
          items</span>
        <span class="font-semibold">View Cart</span>
      </button>
    </div>
  </ng-container>

  <ng-template #notFound>
    <div class="max-w-7xl mx-auto px-4 py-20 text-center">
      <h2 class="text-2xl font-bold text-gray-900">Restaurant not found</h2>
      <button (click)="goBack()" class="mt-4 bg-orange-500 hover:bg-orange-600 text-white rounded-lg px-6 py-2">
        Go Back Home
      </button>
    </div>
  </ng-template>

  <app-footer></app-footer>
</div>